export default {
  methods: {
    /* This method prevents the user from entering any additional decimals when it has exceeded the defined limit.
     * 'type="number"' is required to both handle decimals seperated by either comma or point.
     * @param {Event} event Event reference
     * @param {Number} limit The amount of decimals allowed on the input field
     */
    limitInputDecimals: function (event, limit = 2) {
      // Get the decimals as a string. 
      // Comma (,) seperated decimals will be parsed to point (.) if 'type="Number"' is present on input field.
      const decimalValue = event.target.value.toString().split('.')[1]?.toString();

      // Prevent the user from entering any additional data to the input field, if exceeding the limit
      if (decimalValue?.length >= limit)
        event.preventDefault();
   }
  }
}
